import { render, staticRenderFns } from "./BundelSuketGadar.vue?vue&type=template&id=779bfcfe&scoped=true&"
import script from "./BundelSuketGadar.vue?vue&type=script&lang=ts&"
export * from "./BundelSuketGadar.vue?vue&type=script&lang=ts&"
import style0 from "./BundelSuketGadar.vue?vue&type=style&index=0&id=779bfcfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779bfcfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow})
